import EventLog from "../logger/events";
import { IPV4_REGEX } from "../utils/regex";
import { get as getInitData } from "./initdata";
import { DEVICE_FINGERPRINT } from "./fingerprint";
import { setFingerprintIp } from "./initfingerprint";
import { SAVED_CARDS } from "../collections/savedcards";
import { isEmptyObject } from "../fetcher/support/utils";
import SearchParams, { PARAMS, getParams, parser } from "./searchparams";
import { restrictNetworksList, FRANCO_COUNTRIES_LIST } from "../collections/mobilemoneynetworks";
import { SA_BANKS_LIST } from "../collections/southafricanbanks";
import { eNairaPaymentOptions } from "../collections/enairaoptions";
import Supports from "../utils/supports";
import { isWhiteLabelled } from "../../support/helpers";

import {
  CURRENCIES,
  PAYMENT_OPTIONS,
  CURRENCY_OPTIONS,
  INITIAL_PAYMENT_OPTION,
  getPreferredPaymentOption,
  initializePaymentOptions
} from "./paymentoptions";

import initializeBanks, {
  ACCOUNT_BANKS_LIST,
  INTERNET_BANKS_LIST,
  USSD_BANKS_LIST
} from "../collections/nigerianbanks";

import {
  callback as __callback__,
  isString,
  isPlainObject,
  matchedString,
  withProperties,
  resolveBoolean,
  withAccessors
} from "../utils";
import { isoCountryOptions } from "../collections/isocountries";
import { capitecPaymentOptions } from "../collections/capitecpaymentoptions";

export let CHARGE_DATA;
let DATA;
let META_DATA;
let FINGERPRINT_SCORE_METAVALUE;

const INIT_ADDRESS_METANAME = "__CheckoutInitAddress";
const FINGERPRINT_SCORE_METANAME = "__FingerprintConfidenceScore";

function __receiveExtraChargeDataUpdate__($initData) {
  if (!CHARGE_DATA) {
    CHARGE_DATA = Object.create(null);
  }

  withProperties(CHARGE_DATA, getParams(
    'amount',
    'campaign_id',
    'country',
    'currency',
    'default_account',
    'customer_email::email',
    'mobilemoney_network',
    'payment_page',
    'payment_plan',
    'PBFPubKey',
    'customer_phone::phone',
    'recurring_stop',
    'redirect_url',
    'settlement_token',
    'txref'
  ));

  __resolveInitUrl__.call(CHARGE_DATA);

  return new Promise(resolve => {
    META_DATA = [];
    FINGERPRINT_SCORE_METAVALUE = Supports.localStorage ? JSON.parse(localStorage.getItem('fp_visitor_data')) : null;

    try {
      META_DATA.push({
        metaname: INIT_ADDRESS_METANAME,
        metavalue: new URL(decodeURIComponent(CHARGE_DATA.init_url)).href
      },
      {
        metaname: FINGERPRINT_SCORE_METANAME,
        metavalue: FINGERPRINT_SCORE_METAVALUE ? FINGERPRINT_SCORE_METAVALUE.confidenceScore : null
      });
    } catch (e) {
      META_DATA.push({
        metaname: INIT_ADDRESS_METANAME,
        metavalue: "N/A"
      },
      {
        metaname: FINGERPRINT_SCORE_METANAME,
        metavalue: FINGERPRINT_SCORE_METAVALUE ? FINGERPRINT_SCORE_METAVALUE.confidenceScore : null
      });
    }


    Object.defineProperty(CHARGE_DATA, "meta", {
      configurable: true,
      value: META_DATA
    });

    if (self.parent !== self) {
      self.parent.postMessage({
        name: "readytorecieve"
      }, "*");

      addEventListener('message', function __handleMessage__({ data, source }) {
        if (source === self.parent) {
          const { name, ...extradata } = isPlainObject(data) ? data : {};

          if (name === "updategotten") {
            removeEventListener('message', __handleMessage__);
            const { applepay, billing, meta, subaccounts, theme, v3 } = extradata;
            try {
              meta.forEach(_metadata => {
                if (isPlainObject(_metadata)) {
                  const { metaname, metavalue } = _metadata;
                  const validMetaValueTypes = { string: true, number: true, boolean: true };
              
                  if (metavalue && isPlainObject(metavalue)) {
                    if (metavalue.metaname && metavalue.metaname !== INIT_ADDRESS_METANAME && metavalue.metaname !== FINGERPRINT_SCORE_METANAME && metavalue.metavalue) {
                      if ([true, false].includes(metavalue.isRequired)) delete metavalue.isRequired

                      if (isString(metavalue.metaname) && validMetaValueTypes[typeof metavalue.metavalue]) {
                        for (let i = 0, len = META_DATA.length; i < len; i++) {
                          if (metavalue.metaname === META_DATA[i].metaname) return;
                        }
                        META_DATA.push(metavalue);
                      }
                    }
                  } else {
                    if (isString(metaname) && metaname) {
                      if (!metavalue) return;
                      for (let i = 0, len = META_DATA.length; i < len; i++) {
                        if (metaname === META_DATA[i].metaname) return;
                      }
  
                      META_DATA.push(_metadata);
                    }
                  }
                }
              });
            } catch (e) {}

            if (isPlainObject(billing)) {
              const fields = [
                "billingaddress", "billingcity", "billingstate",
                "billingzip", "billingcountry", "shippingname",
                "shippingaddress", "shippingcity", "shippingstate",
                "shippingzip", "shippingcountry"
              ];

              try {
                withProperties(CHARGE_DATA, "billing_metadata", {
                  value: Object.freeze(fields.reduce((obj, field) => {
                    obj[field] = billing[field];
                    return obj;
                  }, Object.create(null)))
                });
              } catch (e) {}
            }

            withProperties(CHARGE_DATA, {
              subaccounts,
              meta: META_DATA.filter(Boolean),
              use_v3: Boolean(+v3) === true,
              allowApplePay: applepay === true
            });

            resolve($initData);
          }
        }
      });

      return;
    }

    resolve($initData);
  });
};

function __firstOrNull__(...values) {
  return [].concat(values).filter(Boolean)[0] || null;
}

function __parseCustomerName__() {
  let $fullname;

  const $firstname = SearchParams.get('customer_firstname');
  const $lastname = SearchParams.get('customer_lastname');

  $fullname = SearchParams.get('customer_fullname');

  $fullname = (isString($fullname) ? $fullname : String())
    .split(/\b[^a-z-]+?\b/i)
    .map(name => (name.trim() || null));
  
  $fullname = Array.from(
    new Array(Math.max(2, $fullname.length)),
    (_, i) => ($fullname[i] == undefined ? undefined : $fullname[i])
  );

  const {
    length,
    0: firstname = $firstname,
    [length - 1]: lastname = $lastname
  } = $fullname;

  withProperties(this, {
    firstname,
    lastname,
    names: [firstname, ...$fullname.slice(1, -1), lastname]
  });
}

function __parseIPAddress__($initData) {
  const ip_address = $initData.get('ip');

  let { ipv4, country } = isPlainObject(ip_address)
    ? ip_address
    : (isString(ip_address) ? { ipv4: ip_address } : {});

  ipv4 = matchedString(IPV4_REGEX, ipv4);
  country = matchedString(/^[a-z]{2}$/i, country);

  if (ipv4) {
    setFingerprintIp(ipv4);
  }

  withProperties(this, {
    ip: ipv4,
    ip_country: ipv4 && country && country.toUpperCase()
  });
}

function __resolveBanksLists__($initData) {
  const excludeBanksList = [].concat(
    SearchParams.get('exclude_banks'),
    parser(PARAMS.exclude_banks, $initData.get('exclude_banks'))
  ).filter(Boolean);

  initializeBanks.call($initData, excludeBanksList);

  withProperties(this, {
    banks: Object.freeze(withProperties(Object.create(null), {
      account: ACCOUNT_BANKS_LIST,
      internet: INTERNET_BANKS_LIST,
      ussd: USSD_BANKS_LIST
    }))
  });
}

function __resolveCustomPwbtExpiryTime__() {
  let expires = SearchParams.get('custom_pwbt_expiry');
  const searchParamFields = SearchParams.raw;
  if (!expires) {
    expires = searchParamFields['bank_transfer_expiry'];
  }

  this.expires = __firstOrNull__(expires);
}

function __resolveCheckoutSession__() {
  this.session_duration = __firstOrNull__(
    SearchParams.get('custom_session_duration')
  );
}

function __resolveDiscountDetails__($initData) {
  if ($initData.get('campaignMeta') && $initData.get('discount')) {
    const hasDiscountTrue = META_DATA.some(
      obj => obj.metaname === "discount" && obj.metavalue === true
    );
    // if ($initData.get('discount')['apply_discount']) { //TODO: Review implementation long-term
    if ($initData.get('discount')['apply_discount'] || hasDiscountTrue) {
      let extraCampaignItems = $initData.get('campaignMeta');

      withProperties(this, {
        campaign: { ...$initData.get('discount')['campaign'], ...extraCampaignItems},
        new_amount: $initData.get('discount')['amount_to_pay'],
        discount: $initData.get('discount')['discount_to_apply'],
        discounted_value: $initData.get('discount')['discounted_value'],
        discount_type: $initData.get('discount')['discount_type']
      });
    }
    // }
  }
}

function __resolveMerchantData__($initData) {
  let preferences;

  const whiteLabelled = isWhiteLabelled(SearchParams.get('currency'), SearchParams.get('country'));

  this.merchant_name = __firstOrNull__(
    // SearchParams.get('custom_title'),
    $initData.get('merchant.name'),
    whiteLabelled ? 'Merchant' : 'Flutterwave Merchant'
  );

  this.merchant_title = SearchParams.get('custom_title') || null;

  this.banktransfer_beneficiary_name = __firstOrNull__(
    SearchParams.get('custom_narration'),
    $initData.get('merchant.name'),
  );

  this.merchant_logo = __firstOrNull__(
    SearchParams.get('custom_logo'),
    $initData.get('merchant.logo'),
    // White-labelled regions get no generic fallback asset at all; the header
    // renders the merchant initial instead.
    whiteLabelled ? null : new URL('/assets/img/rave-logo.png', process.env.CHECKOUT_BASE_URL).href
  );

  // this.public_key = SearchParams.get('PBFPubKey');
  // this.bearing_fees = resolveBoolean($initData.get('initial.merchant_bearing'), false);

  // this.powered_by = __firstOrNull__(
  //   $initData.get('powered_by_title'),
  //   'Flutterwave'
  // );

  preferences = $initData.get('preferences');
  preferences = isPlainObject(preferences) ? preferences : {};

  withProperties(preferences, {
    merchant_bears_fees: resolveBoolean($initData.get('initial.merchant_bearing'), false),
    use_dynamic_currency_conversion: resolveBoolean($initData.get('enabled_for_dcc'), false),
    use_old_saved_card_flow: resolveBoolean($initData.get('use_old_saved_card_flow'), false),
    use_secureauth_for_card: resolveBoolean(null /* isAirtel() */, false)
  });

  if (isPlainObject(preferences) && !isEmptyObject(preferences)) {
    Object.keys(preferences).forEach(preference => {
      if (preference in this.preferences) {
        this.preferences[preference] = resolveBoolean(
          preferences[preference],
          this.preferences[preference]
        );
      }
    });
  }
}

function __resolveInitUrl__() {
  let init_url = null;

  if (self === self.top) {
    init_url = self.location.href;
  } else {
    try {
      const parentWindow = window.opener || window.parent;
      const hasParent = parentWindow && parentWindow !== window.self;
      // const isWindowOpen = window.opener && window.opener === parentWindow;
    
      // this.init_url = (
      //   hasParent ? parentWindow : window.self
      // ).location.href;

      init_url = hasParent ? null : (self.top || self).location.href;
    } catch (e) {}
  }

  withProperties(this, {
    init_url: __firstOrNull__(
      init_url,
      SearchParams.get('init_url')
    )
  });
}

function __aggregateChargeData__($initData) {
  const [, mpesaPaybill, pushSTK] = String(
    $initData.get('powered_by_title') || $initData.get('poweredbytitle')
  ).match(/^(\d+)(?::([^:]*))?$/) || [];

  withProperties(CHARGE_DATA, {
    mpesaPaybill,
    canSendSTKPushNotification: pushSTK !== 'NOSTK',
    description: __firstOrNull__(SearchParams.get('custom_description')),
    integrity_hash: __firstOrNull__($initData.get('integrity_hash'), SearchParams.get('integrity_hash')),
    narration: __firstOrNull__(SearchParams.get('custom_narration')),
    charge_type: $initData.get('charge_type'),
    cycle: $initData.get('cycle'),
    include_discount_amount: resolveBoolean(SearchParams.get('include_discount_amount'), false),
    modalauditid: $initData.get('id'),
    forter_site_id: $initData.get('forter_site_id'),
    isHighRisk: resolveBoolean($initData.get('isHighRisk'), false),
    use_authm_control: resolveBoolean($initData.get('authm_control'), true),
    merchant_vat_amount: __firstOrNull__(SearchParams.get('merchant_vat_amount')),
    preferences: withProperties(Object.create(null), {
      blacklist_saved_cards: false,
      can_switch_to_paymob: false,
      ignore_mpesa_fallback: false,
      merchant_bears_fees: false,
      prefers_reduced_tracking: false,
      prefers_hidden_email: false,
      prefers_language_translation: false,
      should_redirect_on_fail: false,
      use_dynamic_currency_conversion: false,
      use_old_saved_card_flow: false,
      use_secureauth_for_card: false,
    }, true)
  });

  withAccessors.call(CHARGE_DATA, 'currencies', () => CURRENCIES);
  withAccessors.call(CHARGE_DATA, 'payment_options', () => PAYMENT_OPTIONS);
  withAccessors.call(CHARGE_DATA, 'currency_options', () => CURRENCY_OPTIONS);
  withAccessors.call(CHARGE_DATA, 'device_fingerprint', () => DEVICE_FINGERPRINT);

  withAccessors.call(CHARGE_DATA, 'initial_currency', () => (
    INITIAL_PAYMENT_OPTION['currency'] ||
    SearchParams.get('currency')
  ));

  withAccessors.call(CHARGE_DATA, 'initial_method', () => {
    const currency = CHARGE_DATA['initial_currency'];
    const options = CURRENCY_OPTIONS[currency] || [];

    return (
      getPreferredPaymentOption(currency, options) ||
      INITIAL_PAYMENT_OPTION['option'] ||
      options[0] ||
      null
    );
  });

  withProperties(CHARGE_DATA, {
    mobilemoneyfranco_countries: FRANCO_COUNTRIES_LIST,
    momo_networks: isPlainObject($initData.get('momo_networks')) ? $initData.get('momo_networks') : null
  });
  withAccessors.call(CHARGE_DATA, 'mobilemoney_networks', () => restrictNetworksList(CHARGE_DATA['momo_networks']));
  withAccessors.call(CHARGE_DATA, 'saved_cards', () => SAVED_CARDS);
  withAccessors.call(CHARGE_DATA, 'enaira_payment_options', () => eNairaPaymentOptions);
  withAccessors.call(CHARGE_DATA, 'iso_countries_options', () => isoCountryOptions);
  withAccessors.call(CHARGE_DATA, 'sa_banks', () => SA_BANKS_LIST);
  withAccessors.call(CHARGE_DATA, 'capitec_options', () => capitecPaymentOptions);
  withAccessors.call(CHARGE_DATA, 'meta', () => META_DATA);

  __parseCustomerName__.call(CHARGE_DATA);
  __parseIPAddress__.call(CHARGE_DATA, $initData);
  __resolveBanksLists__.call(CHARGE_DATA, $initData);
  __resolveCustomPwbtExpiryTime__.call(CHARGE_DATA);
  __resolveCheckoutSession__.call(CHARGE_DATA);
  __resolveDiscountDetails__.call(CHARGE_DATA, $initData);
  __resolveMerchantData__.call(CHARGE_DATA, $initData);

  initializePaymentOptions($initData);
  DATA = Object.freeze(CHARGE_DATA);
  EventLog.initializedModal.call(CHARGE_DATA);
}

function __ready__(callback) {
  return (
    DATA
      ? Promise.resolve()
      : getInitData()
        .then(__receiveExtraChargeDataUpdate__)
        .then(__aggregateChargeData__)
  ).then(__callback__(callback));
}

export default function getChargeData() {
  return __ready__(() => CHARGE_DATA);
};
